module.exports = "https://r.nearpod.com/assets/media/image/search-icon-48270be0895842fa77ab67fa4fc71f5d.svg";